<template>
  <v-container fluid tag="section" class="px-3">
    <v-row>
      <!--<v-col class="column left-column py-0">
          <v-card class="tree mb-0 w-100">
              <v-card-text class="card-tree pa-4 pt-10">
                  <v-btn class="card-tree-title" color="primary">Категории звонков</v-btn>
                  <v-treeview
                      class="card-tree-content"
                      v-model="tree"
                      :open="open"
                      :items="menuItems"
                      item-key="name"
                      open-on-click
                      dense
                  />
              </v-card-text>
          </v-card>
      </v-col>-->
      <v-col>
        <!--<v-col class="column right-column py-0 pl-0">-->
        <base-material-card
          inline
          icon="mdi-clipboard-text"
          title="Таблица истории звонков"
          class="px-5 py-3 mb-0 col-sm-12"
        >
          <v-card class="my-0">
            <v-card-title class="pl-0 mb-2">
              <v-text-field
                v-model="search"
                append-icon="search"
                :label="$t('search')"
                color="secondary"
                single-line
                hide-details
                class="search-width"
              ></v-text-field>
            </v-card-title>
          </v-card>
          <v-data-table
            :headers="headers"
            :items="calls"
            class="caption"
            :mobile-breakpoint="900"
            :page.sync="page"
            @page-count="pageCount = $event"
            :fixed-header="true"
            :height="tableHeight"
            hide-default-footer
            :items-per-page="itemsPerPage"
            hoverable="false"
          >
            <template v-slot:item.time="{ item }">
              <time class="d-flex flex-column text-overflow caption">
                <span>{{ item.start }}</span>
              </time>
            </template>

            <!--                        <template v-slot:item.typeCall="{ item }">
                                        &lt;!&ndash;<span class="text-overflow caption text-capitalize">
                                            <v-icon
                                                    x-small
                                                    :class="{'red&#45;&#45;text': item.status == 'Нет ответа', 'green&#45;&#45;text': item.status == 'Принят'}"
                                            >mdi-phone-outline</v-icon>
                                            {{ item.typeCall }}
                                        </span>&ndash;&gt;
                                        <v-icon color="#5FA057">phone</v-icon>
                                        Внутренние
                                    </template>-->

            <template v-slot:item.disposition="{ item }">
              <!--<span
                      class="text-overflow caption"
                      :class="{'red&#45;&#45;text': item.status == 'Нет ответа', 'green&#45;&#45;text': item.status == 'Принят'}"
              >{{ item.status }}</span>-->
              <div v-if="item.disposition === 'ANSWERED'"
                   style="color: #5FA057;">
                Принят
              </div>
              <div v-else-if="item.disposition === 'NO ANSWER'"
                   style="color: #BF180C;">
                Нет ответа
              </div>
              <div v-else
                   style="color: #14347B;">
                Занят
              </div>
            </template>

            <template v-slot:item.clid="{ item }">
              <div
                class="d-flex align-center caption text-capitalize"
              >
                <!--                                <v-avatar size="32" class="mr-2">
                                                    &lt;!&ndash;<img :src="item.url1" class="elevation-0"/>&ndash;&gt;
                                                    <img src="https://randomuser.me/api/portraits/women/16.jpg" class="elevation-0"/>
                                                </v-avatar>-->

                <!--                <div class="text-left">
                                  <p class="text-overflow ma-0 td-max-width">{{ item.clid }}</p>
                                </div>-->

                <div v-if="item.phone_s_r_c">
                  <div>
                    {{ item.phone_s_r_c.fullname }}
                  </div>
                  <div>
                    {{ item.phone_s_r_c.name }}
                  </div>
                </div>

                <div v-else>
                  {{ item.clid }}
                </div>

              </div>
            </template>

            <template v-slot:item.dst="{ item }">
              <div
                class="d-flex align-center caption text-capitalize"
              >
                <!--                                <v-avatar size="36" class="mr-2">
                                                    &lt;!&ndash;<img :src="item.url2" class="elevation-0"/>&ndash;&gt;
                                                    <img src="https://randomuser.me/api/portraits/women/15.jpg" class="elevation-0"/>
                                                </v-avatar>-->
                <!--                <div class="text-left">
                                  <p class="text-overflow ma-0 td-max-width">
                                    {{ item.dst }} - {{ item.lastdata }}
                                  </p>
                                </div>-->

                <div v-if="item.phone_d_s_t">
                  <div>
                    {{ item.phone_d_s_t.fullname }}
                  </div>
                  <div>
                    {{ item.phone_d_s_t.name }}
                  </div>
                </div>

                <div v-else>
                  {{ item.dst }} - {{ item.lastdata }}
                </div>

              </div>
            </template>

            <!-- Филиал -->
            <template v-slot:item.branch="{ item }">
              <!--<span class="text-overflow caption">{{ item.branch }}</span>-->
              <span class="text-overflow caption">Днепр</span>
            </template>

            <!-- Время ожидания -->
            <template v-slot:item.duration="{ item }">
                            <span class="text-overflow caption">
                                {{ getWaitingTime(item.duration, item.billsec) }}
                            </span>
            </template>

            <!-- Длительность -->
            <template v-slot:item.billsec="{ item }">
                            <span class="text-overflow caption">
                                {{ getTalkTime(item.billsec) }}
                            </span>
            </template>

            <template v-slot:item.linkedid="{ item }">
              <div class="text-overflow caption">

                <a :href="`http://135.181.84.244/${item.linkedid}.wav`"
                   target="_blank"
                   style="text-decoration: none"
                >
                  <v-icon color="#14347B">mdi-play</v-icon>
                </a>
                <!--                                <v-icon color="#14347B">mdi-download</v-icon>
                                                <v-icon color="#14347B">mdi-content-copy</v-icon>
                                                <v-icon color="#14347B">mdi-email-outline</v-icon>-->

                <!--<v-btn icon small class="action-button">
                    <v-icon small>mdi-play-outline</v-icon>
                </v-btn>
                <v-btn icon small class="action-button">
                    <v-icon small>mdi-download-outline</v-icon>
                </v-btn>
                <v-btn icon small class="action-button">
                    <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                <v-btn icon small class="action-button">
                    <v-icon small>mdi-email-outline</v-icon>
                </v-btn>-->
              </div>
            </template>
            <v-data-footer :show-current-page="true"></v-data-footer>
          </v-data-table>

          <div class="text-center mt-3 pagination-block">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="totalVisiblePagination"
              color="#0051ff"
            ></v-pagination>
            <span class="row-options">
                            <label class="mr-2">Показывать строк</label>
                            <v-select
                              :items="rowsOptions"
                              v-model="rows"
                              label
                              dense
                              solo
                              @change="setRows"
                              class="rows-options-select"
                              item-color
                            ></v-select>
                        </span>
          </div>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import PhoneNumberTooltip from './components/PhoneNumberTooltip'
import { EventBus } from '../../../event-bus/event-bus'

import axios from 'axios'

export default {
  name: 'CallsHistory',

  components: { PhoneNumberTooltip },

  data: function () {
    return {
      open: ['public'],
      tree: [],
      search: '',
      tableHeight: 'auto',
      page: 1,
      pageCount: 0,
      itemsPerPage: 15,
      totalVisiblePagination: 7,
      rowsOptions: [3, 5],
      rows: 5,
      isActive: false,

      menuItems: [
        {
          id: 1,
          name: 'Все звонки',
          children: [{ id: 2, name: 'Исходящие' }, { id: 3, name: 'Пропущенные' }],
        }, {
          id: 4,
          name: 'Мои звонки',
          children: [{ id: 5, name: 'Исходящие' }, { id: 6, name: 'Пропущенные' }],
        }, {
          id: 7,
          name: 'Мои группы',
          children: [
            {
              id: 8,
              name: 'Все звонки группы',
              children: [{ id: 9, name: 'Исходящие' }, { id: 10, name: 'Пропущенные' }],
            },
            {
              id: 11,
              name: 'Филиал Днепр',
              children: [{ id: 12, name: 'Исходящие' }, { id: 13, name: 'Пропущенные' }],
            },
            {
              id: 14,
              name: 'Филиал Запорожье',
              children: [{ id: 15, name: 'Исходящие' }, { id: 16, name: 'Пропущенные' }],
            },
          ],
        },
      ],

      headers: [
        {
          text: 'Время/дата',
          value: 'start',
          align: 'center',
          class: 'text-overflow font-weight-bold caption',
        },
        /*{
                        text: 'Тип звонка',
                        value: 'typeCall',
                        align: 'left',
                        class: 'text-overflow font-weight-bold caption',
                    },*/
        {
          text: 'Статус',
          value: 'disposition',
          align: 'left',
          class: 'text-overflow font-weight-bold caption',
        }, {
          text: 'От кого',
          value: 'clid',
          align: 'left',
          class: 'text-overflow font-weight-bold caption',
        }, {
          text: 'Кому',
          value: 'dst',
          align: 'left',
          class: 'text-overflow font-weight-bold caption',
        }, {
          text: 'Филиалы',
          value: 'branch',
          align: 'center',
          class: 'text-overflow font-weight-bold caption',
        }, {
          text: 'Ожидание',
          value: 'duration',
          align: 'center',
          class: 'text-overflow font-weight-bold caption',
        }, {
          text: 'Длительность',
          value: 'billsec',
          align: 'center',
          class: 'text-overflow font-weight-bold caption',
        }, {
          text: 'Действие',
          value: 'linkedid',
          align: 'center',
          sortable: false,
          class: 'text-overflow font-weight-bold caption',
        },
      ],

      calls: [
        {
          date: '03.08.2019',
          time: '14:53:23',
          typeCall: 'входящий',
          status: 'Нет ответа',
          fromUser: 'Петров Петр Петрович',
          toUser: 'Григорьев Витольд Константинович',
          branch: 'филиал Днепр',
          waiting: '00:42:00',
          firstUserNumber: '+380950102030',
          secondUserNumber: '+380504433366',
          url1: 'https://randomuser.me/api/portraits/men/11.jpg',
          url2: 'https://randomuser.me/api/portraits/men/20.jpg',

          start: '03.05.2019 14:53:23',
          type: 'Исходящий',
          disposition: 'Нет ответа',
          src: 'Иван Иванович Иванович 901',
          dst: 'Петро Петренко Пертикович +38 022 333 22 33',
          duration: 0,
          billsec: 4,
          linkedid: '1568795397.63',
        },
      ],

      // выбранный период:
      chPeriod: {
        start_date: '',
        end_date: '',
      },
    }
  },

  methods: {
    setRows () {
      this.itemsPerPage = this.rows
    },

    /**
     * Получить историю звонков
     */
    getListCallHistory () {
      axios({
        method: 'get',
        url: process.env.VUE_APP_API_URL_PHONE + 'get-list-call-history',
      }).then((response) => {
        this.calls = response.data
      }).catch(error => alert(error))
    },

    /**
     * Получить время ожидания
     *
     * @param duration
     * @param billsec
     * @returns {string}
     */
    getWaitingTime (duration, billsec) {

      let waitingTime = duration - billsec
      let m = waitingTime / 60 ^ 0
      let s = waitingTime - m * 60

      return (m < 10 ? '0' + m : m) + ':'
        + (s < 10 ? '0' + s : s)
    },

    /**
     * Получить время разговора
     *
     * @param billsec
     * @returns {string}
     */
    getTalkTime (billsec) {

      let h = billsec / 3600 ^ 0
      let m = (billsec - h * 3600) / 60 ^ 0
      let s = billsec - h * 3600 - m * 60

      return (h < 10 ? '0' + h : h) + ':'
        + (m < 10 ? '0' + m : m) + ':'
        + (s < 10 ? '0' + s : s)
    },

    /**
     * Получить историю звонков за период
     */
    getListCallHistoryPeriod () {
      axios({
        method: 'get',
        url: process.env.VUE_APP_API_URL_PHONE + 'get-list-call-history-period',
        params: {
          start_date: this.chPeriod.start_date.format('YYYY-MM-DD'),
          end_date: this.chPeriod.end_date.format('YYYY-MM-DD'),
        },
      }).then((response) => {
        this.calls = response.data
      }).catch(error => alert(error))
    },
  },

  created () {

    this.getListCallHistory()

    EventBus.$on('changePeriod', dataPassed => {
      this.chPeriod = dataPassed
      this.getListCallHistoryPeriod()
    })

  },

  destroyed () {
    this.EventBus.$off('changePeriod')
  },
}
</script>

<style lang="scss" scoped>

.action-button:hover {
  color: #0051ff;
  transition: 0.2s;
}

// сетка

.row {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}

.column {
  height: 100%;
}

.left-column {
  flex: 0 0 290px;
}

.right-column {
  min-width: 370px;
}

.v-card {
  border-radius: 4px !important;
}

// левая колонка

.v-card.tree {
  height: calc(100% - 30px);
}

.card-tree {
  position: relative;
  height: 100%;
}

.card-tree-title {
  position: absolute;
  top: -17px;
  width: calc(100% - 32px);
  min-height: 48px;
  font-size: 14px !important;
}

.card-tree-content {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

// правая колонка

.v-card--material {
  height: calc(100% - 30px);
}

.v-data-table {
  height: calc(100% - 160px);
  overflow: auto;
}

// медиазапросы

@media (max-width: 980px) {
  .row-options label {
    display: none !important;
  }
}

@media (max-width: 743px) {
  .v-card.tree {
    height: auto;
  }

  .row {
    height: auto;
  }

  .right-column {
    padding-left: 12px !important;
  }
}

// пагинация в таблице

.pagination-block {
  display: flex;

  .row-options {
    display: flex;
    position: absolute;
    right: 20px;
    align-items: baseline;

    .v-select {
      width: 50px;
    }
  }
}


</style>
